var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"filter-base-input"},[(_vm.hasPrefix)?_c('div',{staticClass:"filter-base-input__prefix"},[_vm._v(_vm._s(_vm.prefix))]):_vm._e(),_vm._t("default"),(_vm.hasSuffix)?_c('div',{staticClass:"filter-base-input__suffix"},[_vm._v(_vm._s(_vm.suffix))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }